'use client'

import clsx from 'clsx'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import React, { useMemo, useState } from 'react'

import { IAmbulance, IPriceListGroup } from '@/_types'

interface IProps {
	ambulance: IAmbulance
	priceGroups: IPriceListGroup[]
}

export default function AAmbulanceContentPriceGroups({ ambulance, priceGroups }: IProps) {
	const t = useTranslations('pages.ambulance_detail')
	const maxItems = 4

	if (!priceGroups || !priceGroups?.length) {
		return null
	}

	const [showMore, setShowMore] = useState(false)
	const [isExpanded, setIsExpanded] = useState(false)

	const priceGroupsToShow = useMemo(() => {
		return showMore ? priceGroups : priceGroups.slice(0, maxItems)
	}, [priceGroups, showMore])

	const handleToggleShowMore = (e: React.MouseEvent) => {
		e.preventDefault()
		setShowMore(prev => !prev)
	}

	return (
		<div
			id='sluzby'
			className={clsx('item_accord accorditem under pdt-0lg pdt-30', {
				expanded: isExpanded
			})}
		>
			<h2
				className='item_accord_head accordhead mgt-0lg mgt-20'
				onClick={() => setIsExpanded(prev => !prev)}
			>
				<span>{t('services')}</span>
				<svg className='sico'>
					<use href='/assets/layout/icons.svg#s_ar1_d'></use>
				</svg>
			</h2>

			<div className='item_accord_expand '>
				<div>
					<div className='item_accord_content '>
						<ul className='text-btn'>
							{priceGroupsToShow.map(group => (
								<li key={group.id}>
									<div className='text px-4'>{group.name}</div>
									<Link
										href={`/ambulancie/${ambulance.slug}/sluzby/${group.slug}`}
										title={group.name}
										className='btn_basic wmin200 mgt-15lg'
										prefetch={false}
									>
										<span>{t('show')}</span>
										<span>
											<span>
												<svg className='sico'>
													<use href='/assets/layout/icons.svg#s_ar2_r' />
												</svg>
											</span>
											<span>
												<svg className='sico'>
													<use href='/assets/layout/icons.svg#s_ar2_r' />
												</svg>
											</span>
										</span>
									</Link>
								</li>
							))}
						</ul>
						{priceGroups.length > maxItems && (
							<div className='dflex justify-center mgt-15'>
								<Link
									href='#'
									title={showMore ? t('showLess') : t('showMore')}
									className='btn_basic type7 down'
									onClick={handleToggleShowMore}
									prefetch={false}
								>
									<span>{showMore ? t('showLess') : t('showMore')}</span>
									<span>
										<span>
											<svg className='sico'>
												{showMore ? (
													<use href='/assets/layout/icons.svg#s_ar1_u' />
												) : (
													<use href='/assets/layout/icons.svg#s_ar1_d' />
												)}
											</svg>
										</span>
										<span>
											<svg className='sico'>
												{showMore ? (
													<use href='/assets/layout/icons.svg#s_ar1_u' />
												) : (
													<use href='/assets/layout/icons.svg#s_ar1_d' />
												)}
											</svg>
										</span>
									</span>
								</Link>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
